import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = () => {
    const [pageLoaded, setPageLoaded] = useState(false);

    // Wait for page to load before enabling smooth scrolling
    useEffect(() => {
        const handleLoad = () => {
            setPageLoaded(true);
        };

        if (document.readyState === 'complete') {
            setPageLoaded(true);
        } else {
            window.addEventListener('load', handleLoad);
        }

        return () => window.removeEventListener('load', handleLoad);
    }, []);

    // Custom scroll behavior that waits for page load
    const scrollWithDelay = (el) => {
        if (pageLoaded) {
            setTimeout(() => {
                el.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            }, 100); // Small delay to ensure everything is rendered
        } else {
            // If page not loaded, wait a bit longer
            setTimeout(() => {
                el.scrollIntoView({ 
                    behavior: 'smooth', 
                    block: 'start' 
                });
            }, 500);
        }
    };

    return (
        <>
            <HashLink 
                className="px-4 font-extrabold text-claravio-blue-900 hover:text-blue-900" 
                smooth 
                to="/#hero"
                scroll={scrollWithDelay}
            >
                Home
            </HashLink>
            <HashLink 
                className="px-4 font-extrabold text-claravio-blue-900 hover:text-blue-900" 
                smooth 
                to="/about"
                scroll={scrollWithDelay}
            >
                About Us
            </HashLink>
            <HashLink 
                className="px-4 font-extrabold text-claravio-blue-900 hover:text-blue-900" 
                smooth 
                to="/#services"
                scroll={scrollWithDelay}
            >
                Our Solutions
            </HashLink>
            <HashLink 
                className="text-white bg-claravio-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-6 py-3 shadow-xl rounded-xl" 
                smooth 
                to="/contact"
                scroll={scrollWithDelay}
            >
                Contact Us
            </HashLink>
        </>
    )
}

export default NavLinks;
